import axios from "axios";
import { authHeader } from './utils'
import {API_URL} from '../config'


export const siteDataService = async () => {
  try {
    let options = {
      headers: {
        "content-type": "application/json",
        ...authHeader()
      },
    };
    const response = await axios.get(
      `${API_URL}/homeView/getHomeData`,
      options
    );
    return response.data;
  } catch (e) {
    return e;
  }
};
